module.exports = __webpack_public_path__ + "img/dalou_8_4.f07d7276.png";